<script setup>
// import TheWelcome from '../components/TheWelcome.vue'
import Navbar from '@/components/Navbar.vue';
import Landing from '@/components/Landing.vue'
import ProductItem from '@/components/HomeCompoent/ProductItem.vue';
import OurServices from '@/components/HomeCompoent/OurServices.vue';
import HowWork from '@/components/HomeCompoent/HowWork.vue';
import WhyUs from '@/components/HomeCompoent/WhyUs.vue';
import Footer from '@/components/SharedUI/Footer.vue';
import BreadCrumbNav from "@/components/SharedUI/BreadCrumb.vue"
import { onMounted } from 'vue';


</script>

<template>
  <Navbar/>
  <main >
    <BreadCrumbNav/>
    <!-- <TheWelcome /> -->
     <Landing/>
     <!-- <section class="section-spacing"> -->

       <ProductItem />
     <!-- </section> -->
     <!-- <section class="section-spacing"> -->
       <OurServices/>

     <!-- </section> -->
     <!-- <section class="section-spacing"> -->

       <HowWork/>
     <!-- </section>
     <section class="section-spacing"> -->

       <WhyUs/>
     <!-- </section> -->
     <Footer/>  
  </main>
</template>

<style>
.section-spacing {
  margin-top: 100px;
  /* margin-bottom: 100px; */
}

@media (max-width: 768px) {
  .section-spacing {
    margin-top: 60px;
    /* margin-bottom: 60px; */
  }
}


</style>